import { Injectable } from '@angular/core';
//import { SnackbarService, SnackbarConfig, SnackbarFade } from "ngx-heyl-snackbar";



@Injectable()
export class AlertService {
   

    constructor() {
    }


    

}


// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/shared/services/alert.service.ts